import { useMemo, useState } from "react";
import TradutorMapa from "../../pages/Vendas/TradutorMapa";
import CommercialModal from "../../Components/Common/ModalContatoComercial";

const padTo2Digits = (num) => num.toString().padStart(2, "0");

const formatarPeriodoEvento = (dataInicioStr, dataFimStr) => {
    try {
        if (!dataInicioStr || !dataFimStr) return "";

        const dataInicio = new Date(dataInicioStr);
        const dataFim = new Date(dataFimStr);

        const diaInicio = padTo2Digits(dataInicio.getUTCDate());
        const mesInicio = padTo2Digits(dataInicio.getUTCMonth() + 1);
        const anoInicio = dataInicio.getUTCFullYear().toString().slice(-2);

        const diaFim = padTo2Digits(dataFim.getUTCDate());
        const mesFim = padTo2Digits(dataFim.getUTCMonth() + 1);
        const anoFim = dataFim.getUTCFullYear().toString().slice(-2);

        return `${diaInicio}/${mesInicio}/${anoInicio} a ${diaFim}/${mesFim}/${anoFim}`;
    } catch (error) {
        console.error("Erro ao formatar datas:", error);
        return "";
    }
};

const SidebarFeiraNovo = ({
  data,
  corPrincipal,
  corSecundaria,

  isMobile,
  setOpenMobile,

  whatsappPrincipal,
  nomeFeira,
  mensagemPadrao,
  setOpenModalQueroExpor,

  isOpen = true,
  onToggle, 
  showTradutor = true,

  idFeira, 
  isVisualizacaoInterna
}) => {
  
  const dados = data?.retorno?.dados || {};

  const feiraNome = nomeFeira || dados?.nome || "";
  const feiraDescricao = dados?.descricao || "";
  const logoUrl = dados?.logoUrl || "";
  const [activeTab, setActiveTab] = useState('sobre');
  const [exibirModal, setExibirModal] = useState(false);

  const contatoComercial = [
    { nome: feiraNome, whatsapp_principal: whatsappPrincipal },
  ];

  const hasData = (obj) => {
    return (
      obj &&
      Object.keys(obj).length > 0 &&
      Object.values(obj).some((val) => val !== null && val !== undefined && val !== "")
    );
  };

  const periodoEventoFormatado = useMemo(() => {
    if (dados?.data_inicio && dados?.data_fim) {
      return formatarPeriodoEvento(dados.data_inicio, dados.data_fim);
    }
    return "";
  }, [dados?.data_inicio, dados?.data_fim]);

  const renderEndereco = () => {
    const { rua, numero, complemento, bairro, cidade, estado, cep } = dados || {};
    const enderecoData = { rua, numero, complemento, bairro, cidade, estado, cep };

    if (!hasData(enderecoData)) return null;

    const endereco = [];
    if (rua) endereco.push(rua);
    if (numero) endereco.push(numero);
    if (complemento) endereco.push(complemento);
    if (bairro) endereco.push(bairro);

    const cidadeEstado = [];
    if (cidade) cidadeEstado.push(cidade);
    if (estado) cidadeEstado.push(estado);

    const abrirGoogleMaps = () => {
      const enderecoCompleto = `${rua || ""}, ${numero || ""} - ${bairro || ""}, ${cidade || ""} - ${
        estado || ""
      }, ${cep || ""}`;
      const enderecoCodificado = encodeURIComponent(enderecoCompleto);
      window.open(`https://www.google.com/maps/search/?api=1&query=${enderecoCodificado}`);
    };

    return (
      <div style={{ marginTop: "1rem" }}>
        <div style={{ background: "#f7f7f7", padding: "1rem", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.15) 1px 2px 2px 1px" }}>
          {endereco.length > 0 && <p style={{ color: "#878A99", marginBottom: "0.1rem" }}>{endereco.join(", ")}</p>}
          {cidadeEstado.length > 0 && <p style={{ color: "#878A99", marginBottom: "0.1rem" }}>{cidadeEstado.join(" - ")}</p>}
          {cep && <p style={{ color: "#878A99", marginBottom: "0.1rem" }}>CEP: {cep}</p>}

          <button
            onClick={abrirGoogleMaps}
            style={{
              width: "100%",
              display: "block",
              backgroundColor: corPrincipal,
              color: "white",
              border: "none",
              padding: "0.5rem 1rem",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 500,
              marginTop: "0.5rem",
            }}
          >
            <i className="ri-road-map-line" style={{ color: "white", margin: "0 8px" }}></i>
            Como chegar
          </button>
        </div>
      </div>
    );
  };

  const renderContatos = () => {
    const { telefone, email } = dados || {};
    const telefoneValido = telefone && typeof telefone === "string" && telefone.trim() !== "" && telefone !== "null";
    const emailValido = email && typeof email === "string" && email.trim() !== "" && email !== "null";

    if (!telefoneValido && !emailValido) return null;

    return (
      <div style={{ marginTop: "1rem" }}>
        <div style={{ background: "#f7f7f7", padding: "1rem", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.15) 1px 2px 2px 1px" }}>
          {telefoneValido && <p style={{ color: "#878A99", marginBottom: emailValido ? "0.1rem" : 0 }}>{telefone}</p>}
          {emailValido && <p style={{ color: "#878A99", marginBottom: 0 }}>{email}</p>}
        </div>
      </div>
    );
  };

  const renderRedesSociais = () => {
    const { facebook, instagram, youtube, linkedin, twitter, tiktok } = dados || {};
    const redes = [];
    if (facebook) redes.push({ icon: "bx bxl-facebook-circle", url: facebook });
    if (instagram) redes.push({ icon: "bx bxl-instagram", url: instagram });
    if (youtube) redes.push({ icon: "bx bxl-youtube", url: youtube });
    if (linkedin) redes.push({ icon: "bx bxl-linkedin-square", url: linkedin });
    if (twitter) redes.push({ icon: "bx bxl-twitter", url: twitter });
    if (tiktok) redes.push({ icon: "bx bxl-tiktok", url: tiktok });

    if (redes.length === 0) return null;

    return (
      <div className="fair-social">
        {redes.map((rede, index) => (
          <a key={index} href={rede.url} target="_blank" rel="noreferrer">
            <i className={rede.icon} style={{ color: "white", fontSize: "24px", margin: "0 8px" }}></i>
          </a>
        ))}
      </div>
    );
  };

  const telefoneWpp = (whatsappPrincipal || "").replace(/\D/g, "");
  const textoWpp = mensagemPadrao || (feiraNome ? `Olá, gostaria de informações sobre a feira ${feiraNome}` : "Olá, gostaria de informações.");

  return (
    <div style={{ "--primary-color": corPrincipal, "--second-color": corSecundaria }}>

        <div className="sidebar-header">
          {isMobile && typeof setOpenMobile === "function" && (
            <button
              onClick={() => setOpenMobile(false)}
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                background: "transparent",
                border: "none",
                fontSize: 26,
                color: "white",
                zIndex: 20,
              }}
              aria-label="Fechar"
              title="Fechar"
            >
              ×
            </button>
          )}

          <div className="fair-logo">
            {logoUrl ? (
              <img src={logoUrl} alt="Logomarca feira" className="event-image" />
            ) : (
              <div style={{ color: "white", padding: 12, textAlign: "center" }}>Logo não disponível</div>
            )}
          </div>

          {renderRedesSociais()}

          {periodoEventoFormatado && (
            <div className="event-meta">
              <span>{periodoEventoFormatado}</span>
            </div>
          )}

          {showTradutor && (
            <div className="event-translate">
              <TradutorMapa />
            </div>
          )}
        </div>

        <div className="sidebar-body">
          <div className="tabs">
            <button 
                className={`tab ${activeTab === 'sobre' ? 'is-active' : ''}`} 
                onClick={() => setActiveTab('sobre')}
            >
                Sobre
            </button>
            { !isVisualizacaoInterna && (
              <button 
                  className={`tab ${activeTab === 'contato' ? 'is-active' : ''}`} 
                  onClick={() => setActiveTab('contato')}>
                  Contato
              </button>)
            }
        </div>

        <div className="tab-panels">
            <div className={`tab-panel ${activeTab === 'sobre' ? 'is-active' : ''}`} id="tab-sobre">
              <h1 className="event-title">{feiraNome}</h1>

              {!!feiraDescricao && <p className="event-text">{feiraDescricao}</p>}

              {renderEndereco()}
            </div>

            <div className={`tab-panel ${activeTab === 'contato' ? 'is-active' : ''}`} id="tab-contato">
              {renderContatos()}

              {telefoneWpp && (
                <div>
                  <button
                    onClick={() => setExibirModal(true)}
                    style={{
                      width: "100%",
                      display: "block",
                      backgroundColor: "#25d366",
                      color: "white",
                      border: "none",
                      padding: "0.5rem 1rem",
                      borderRadius: "5px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: 600,
                      marginTop: "0.5rem",
                    }}>
                    <i className='bx bxl-whatsapp' style={{color: "white", fontSize: "20px", margin: "0 8px"}}></i>
                    Fale com o Comercial
                  </button>
                </div>
              )}

              {!!setOpenModalQueroExpor && (
                <div>
                  <button
                    onClick={() => setOpenModalQueroExpor(true)}
                    style={{
                      width: "100%",
                      display: "block",
                      backgroundColor: corPrincipal,
                      color: "white",
                      border: "none",
                      padding: "0.5rem 1rem",
                      borderRadius: "5px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: 600,
                      marginTop: "0.5rem",
                    }}
                  >
                    <i className="ri-shopping-bag-line" style={{ color: "white", margin: "0 8px" }}></i>
                    Quero Expor
                  </button>
                </div>
              )}
            </div>
        </div>
      </div>

      <CommercialModal 
        isOpen={exibirModal} 
        onClose={() => setExibirModal(false)} 
        contacts={contatoComercial}
        nomeFeira={feiraNome}
        corPrincipal="#25D366"
      />
   
    </div>
  );
};

export default SidebarFeiraNovo;
